/* Autogenerated file, do not edit! */
import { EventSelector, loadContractArtifact, loadContractArtifactForPublic } from '@aztec/aztec.js/abi';
import { Contract, ContractBase, DeployMethod } from '@aztec/aztec.js/contracts';
import { Fr } from '@aztec/aztec.js/fields';
import TrainContractArtifactJson from './train-Train.json';
export const TrainContractArtifact = loadContractArtifact(TrainContractArtifactJson);
/**
 * Type-safe interface for contract Train;
 */
export class TrainContract extends ContractBase {
    constructor(address, wallet) {
        super(address, TrainContractArtifact, wallet);
    }
    /**
     * Creates a contract instance.
     * @param address - The deployed contract's address.
     * @param wallet - The wallet to use when interacting with the contract.
     * @returns A new Contract instance.
     */
    static at(address, wallet) {
        return Contract.at(address, TrainContract.artifact, wallet);
    }
    /**
     * Creates a tx to deploy a new instance of this contract.
     * @param instantiation - Optional address-affecting parameters (salt, deployer / universalDeploy, publicKeys).
     *                       Salt defaults to a random value; the deployer is locked lazily from the first send-time `from`.
     */
    static deploy(wallet, instantiation) {
        return DeployMethod.create(wallet, {
            artifact: TrainContractArtifact,
            postDeployCtor: (instance, wallet) => TrainContract.at(instance.address, wallet),
            args: [],
        }, instantiation);
    }
    /**
     * Creates a tx to deploy a new instance of this contract using the specified constructor method.
     */
    static deployWithOpts(opts, ...args) {
        return DeployMethod.create(opts.wallet, {
            artifact: TrainContractArtifact,
            postDeployCtor: (instance, wallet) => TrainContract.at(instance.address, wallet),
            args,
            constructorNameOrArtifact: opts.method ?? 'constructor',
        }, opts.instantiation);
    }
    /**
     * Returns this contract's artifact.
     */
    static get artifact() {
        return TrainContractArtifact;
    }
    /**
     * Returns this contract's artifact with public bytecode.
     */
    static get artifactForPublic() {
        return loadContractArtifactForPublic(TrainContractArtifactJson);
    }
    static get storage() {
        return {
            user_locks: {
                slot: new Fr(1n),
            },
            solver_locks: {
                slot: new Fr(2n),
            },
            user_lock_hashes: {
                slot: new Fr(3n),
            },
            user_lock_count: {
                slot: new Fr(4n),
            }
        };
    }
    static get events() {
        return {
            UserRefunded: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "refund_to",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        }
                    ],
                    "path": "Train::UserRefunded"
                },
                eventSelector: EventSelector.fromString("0x206370ce"),
                fieldNames: ["hashlock", "refund_to", "amount"],
            },
            UserRedeemed: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "redeemer",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "secret",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "payout",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "excess",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        }
                    ],
                    "path": "Train::UserRedeemed"
                },
                eventSelector: EventSelector.fromString("0xf4931291"),
                fieldNames: ["hashlock", "redeemer", "secret", "payout", "excess"],
            },
            UserLocked: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "sender",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "recipient",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "src_chain",
                            "type": {
                                "kind": "array",
                                "length": 30,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "token",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "timelock",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 64
                            }
                        },
                        {
                            "name": "payout_curve",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "dst_chain",
                            "type": {
                                "kind": "array",
                                "length": 30,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "dst_address",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "dst_amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "dst_token",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "reward_amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "reward_token",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "reward_recipient",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "reward_timelock_delta",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 64
                            }
                        },
                        {
                            "name": "quote_expiry",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 64
                            }
                        },
                        {
                            "name": "user_data",
                            "type": {
                                "kind": "array",
                                "length": 256,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "solver_data",
                            "type": {
                                "kind": "array",
                                "length": 256,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        }
                    ],
                    "path": "Train::UserLocked"
                },
                eventSelector: EventSelector.fromString("0xcd782ad9"),
                fieldNames: ["hashlock", "sender", "recipient", "src_chain", "token", "amount", "timelock", "payout_curve", "dst_chain", "dst_address", "dst_amount", "dst_token", "reward_amount", "reward_token", "reward_recipient", "reward_timelock_delta", "quote_expiry", "user_data", "solver_data"],
            },
            SolverRefunded: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "solver",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "refund_to",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "reward",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        }
                    ],
                    "path": "Train::SolverRefunded"
                },
                eventSelector: EventSelector.fromString("0x730095ea"),
                fieldNames: ["hashlock", "solver", "refund_to", "amount", "reward"],
            },
            SolverRedeemed: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "solver",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "redeemer",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "secret",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "payout",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "excess",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "reward_to",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "reward",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        }
                    ],
                    "path": "Train::SolverRedeemed"
                },
                eventSelector: EventSelector.fromString("0x9ef17859"),
                fieldNames: ["hashlock", "solver", "redeemer", "secret", "payout", "excess", "reward_to", "reward"],
            },
            SolverLocked: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "sender",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "recipient",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "src_chain",
                            "type": {
                                "kind": "array",
                                "length": 30,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "token",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "reward",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "reward_token",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "reward_recipient",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "timelock",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 64
                            }
                        },
                        {
                            "name": "reward_timelock",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 64
                            }
                        },
                        {
                            "name": "payout_curve",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "dst_chain",
                            "type": {
                                "kind": "array",
                                "length": 30,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "dst_address",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "dst_amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "dst_token",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "data",
                            "type": {
                                "kind": "array",
                                "length": 256,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        }
                    ],
                    "path": "Train::SolverLocked"
                },
                eventSelector: EventSelector.fromString("0xc0a57db2"),
                fieldNames: ["hashlock", "sender", "recipient", "src_chain", "token", "amount", "reward", "reward_token", "reward_recipient", "timelock", "reward_timelock", "payout_curve", "dst_chain", "dst_address", "dst_amount", "dst_token", "data"],
            }
        };
    }
}
